const urlDict = {
  region: {
    it: {
      sicily: 'sicilia',
      puglia: 'puglia',
    },
    fr: {
      sicily: 'sicile',
      puglia: 'pouilles',
    },
    de: {
      sicily: 'sizilien',
      puglia: 'apulien',
    },
  },
  villageCategory: {
    it: {
      villas: 'ville',
      'villas-with-sea-views': 'ville-con-vista-mare',
      'villas-with-pools-and-sea-views': 'ville-con-piscina-e-vista-mare',
      'luxury-villas': 'ville-di-lusso',
      'luxury-villas-in-sicily-with-pools': 'ville-di-lusso-con-piscina',
      'villas-with-pool': 'ville-con-piscina',
      'villas-with-pools-near-the-beach':
        'ville-con-piscina-vicino-la-spiaggia',
      'villas-with-saltwater-pools': 'ville-con-piscina-di-acqua-salata',
      'villas-with-heated-pools': 'ville-con-piscina-riscaldata',
      'villas-with-jacuzzis': 'ville-con-jacuzzi',
      'villas-with-pools-near-palermo': 'ville-con-piscina-vicino-palermo',
      'villas-with-pools-near-cefalu': 'ville-con-piscina-vicino-cefalu',
      'villas-with-pools-near-taormina': 'ville-con-piscina-vicino-taormina',
      'villas-near-the-beach': 'ville-vicino-la-spiaggia',
      'villas-for-families': 'ville-per-famiglie',
      'villas-for-families-with-large-garden':
        'ville-per-famiglie-con-ampi-giardini',
      'pet-friendly-villas-in-sicily': 'ville-in-sicilia-pet-friendly',
      'villas-for-couples': 'ville-per-coppie',
      'villas-for-special-occasions': 'ville-per-occasioni-speciali',
      'villas-for-wine-tours': 'ville-per-degustazione-di-vini',
      'countryside-villas': 'ville-entroterra',
    },
    de: {
      villas: 'villen',
      'villas-with-sea-views': 'villen-mit-meeresausblick',
      'villas-with-pools-and-sea-views':
        'ferienhaeser-mit-pool-und-meeresausblick',
      'luxury-villas': 'luxus-villen',
      'luxury-villas-in-sicily-with-pools': 'luxus-ferienhaeuser-mit-pool',
      'villas-with-pool': 'villen-mit-pool',
      'villas-with-pools-near-the-beach':
        'ferienhaeuser-in-strandnaehe-mit-pool',
      'villas-with-saltwater-pools': 'ferienhaeuser-mit-salzwasserpool',
      'villas-with-heated-pools': 'ferienhaeuser-mit-beheiztem-pool',
      'villas-with-jacuzzis': 'ferienhaeuser-mit-whirlpool',
      'villas-with-pools-near-palermo':
        'ferienhaeuser-mit-pool-in-der-naehe-von-palermo',
      'villas-with-pools-near-cefalu':
        'ferienhaeuser-mit-pool-in-der-naehe-von-cefalu',
      'villas-with-pools-near-taormina':
        'ferienhaeuser-mit-pool-in-der-naehe-von-taormina',
      'villas-near-the-beach': 'villen-in-strandnaehe',
      'villas-for-families': 'villen-fuer-familien',
      'villas-for-families-with-large-garden':
        'ferienhaeuser-fuer-familienurlaube-mit-grossem-garten',
      'pet-friendly-villas-in-sicily': 'haustierfreundliche-villen-in-sizilien',
      'villas-for-couples': 'villen-fuer-paare',
      'villas-for-special-occasions': 'villen-fuer-besondere-anlaesse',
      'villas-for-wine-tours': 'ferienhaeuser-fuer-weinverkostungen',
      'countryside-villas': 'ferienhaeuser-auf-dem-land',
    },
    fr: {
      villas: 'villas',
      'villas-with-sea-views': 'villas-avec-vue-sur-mer',
      'villas-with-pools-and-sea-views':
        'villas-avec-piscines-et-vue-sur-la-mer',
      'luxury-villas': 'villas-grand-luxe',
      'luxury-villas-in-sicily-with-pools': 'villas-de-luxe-avec-piscines',
      'villas-with-pool': 'villas-avec-piscine',
      'villas-with-pools-near-the-beach':
        'villa-avec-piscine-proche-de-la-plage',
      'villas-with-saltwater-pools': 'villas-avec-piscines-au-sel',
      'villas-with-heated-pools': 'villas-avec-piscines-chauffees',
      'villas-with-jacuzzis': 'villas-avec-jacuzzis',
      'villas-with-pools-near-palermo':
        'villas-avec-piscines-dans-la-region-de-palerme',
      'villas-with-pools-near-cefalu':
        'villas-avec-piscines-dans-la-region-de-cefalu',
      'villas-with-pools-near-taormina':
        'villas-avec-piscines-pres-de-taormine',
      'villas-near-the-beach': 'villas-proches-des-plages',
      'villas-for-families': 'villas-pour-les-familles',
      'villas-for-families-with-large-garden':
        'villas-familiales-avec-grands-jardins',
      'pet-friendly-villas-in-sicily':
        'villas-en-sicile-pour-nos-amis-les-animaux',
      'villas-for-couples': 'villas-pour-les-couples',
      'villas-for-special-occasions': 'villas-pour-les-grandes-occasions',
      'villas-for-wine-tours': 'villas-pour-les-amateurs-de-vin',
      'countryside-villas': 'villas-a-la-campagne',
    },
  },
};

export default urlDict;
